export const experience = [
  {
    year: "2026",
    period: "Jun 2026 — Actualidad",
    role: "Desarrollador Full Stack",
    company: "VaxThera",
    modality: "Medellín · Híbrido",
    tech: ["Java", "SQL Server"],
    impact: [
      "Desarrollo Full Stack con foco en backend Java y persistencia en Microsoft SQL Server.",
      "Incorporación a un equipo de producto en etapa de crecimiento, aplicando buenas prácticas de las experiencias previas en operaciones.",
    ],
    current: true,
  },
  {
    year: "2025–26",
    period: "Ago 2025 — Jun 2026 · 11 meses",
    role: "Desarrollador Backend — Equipo de Operaciones",
    company: "Grupo SURA (Suramericana S.A.) · vía SETI S.A.S.",
    modality: "Medellín · Híbrido / Remoto",
    tech: ["Java 8/11", "Spring Boot", "Oracle SQL", "XML/XSLT", "OIPA", "AWS", "Azure DevOps", "Outsystems", "Appian"],
    impact: [
      "Soporte y desarrollo backend sobre aplicaciones en producción para procesos de seguros y afiliaciones, con Java, Spring Boot, Oracle SQL, XML y OIPA (Oracle Insurance Policy Administration).",
      "Diagnóstico y resolución de bugs e incidentes en tiempo real, priorizando estabilidad y continuidad del servicio.",
      "Integración con AWS y despliegues mediante Git y Azure DevOps (CI/CD).",
      "Testing de APIs con Postman y mantenimiento evolutivo de microservicios.",
    ],
  },
  {
    year: "2025",
    period: "Ene 2025 — Jul 2025 · 7 meses",
    role: "Desarrollador Pasante · Gestor de Proyecto & Co-líder de Comunidad",
    company: "Protección S.A.",
    modality: "Medellín · Híbrido / Remoto",
    tech: ["Power Apps", "Power Automate", "Power BI", "SharePoint", "TypeScript", "React", "Java 8", "Spring Boot"],
    impact: [
      "Desarrollo de soluciones empresariales con Power Apps, Power Automate y Power BI, reduciendo tiempos de gestión hasta en un 40%.",
      "Co-creación de un sitio SharePoint con TypeScript, JavaScript y React.",
      "Co-líder de una comunidad técnica interna de +50 colaboradores; diseñé y dicté +70 horas de capacitación en Power Platform.",
      "Mantenimiento de microservicios en Java 8 y Spring Boot.",
    ],
  },
  {
    year: "2024–25",
    period: "Mar 2024 — Jul 2025 · 1 año 5 meses",
    role: "Desarrollador Full Stack (freelance)",
    company: "DevSync Technology",
    modality: "Remoto",
    tech: ["Java", "C#", "Python", "React", "Node.js"],
    impact: [
      "Desarrollo de soluciones a medida en Java, C#, Python, React y Node.js para clientes de distintos sectores.",
      "Consultoría tecnológica para microempresas, optimizando procesos con soluciones escalables y de bajo costo.",
      "Integración de bases de datos SQL y NoSQL, cuidando seguridad y rendimiento en cada entrega.",
    ],
  },
  {
    year: "2024",
    period: "Ene 2024 — Dic 2024 · 1 año",
    role: "Desarrollador Front-End React",
    company: "SOVAL",
    modality: "Medellín · Presencial",
    tech: ["React", "JavaScript", "E-commerce"],
    impact: [
      "Diseño y desarrollo de plataformas web y e-commerce con React y JavaScript, mejorando experiencia de usuario y rendimiento en un 30%.",
      "Automatización de flujos de trabajo internos, reduciendo tiempos operativos en tareas críticas.",
      "Implementación de estrategias que aumentaron la visibilidad digital y las ventas potenciales de los clientes.",
    ],
  },
  {
    year: "2022–23",
    period: "2022 — 2023",
    role: "Desarrollador Freelance",
    company: "Independiente",
    modality: "Remoto",
    tech: ["Java", "C#", "Python", "React", "Node.js", "Outsystems"],
    impact: [
      "Desarrollo de proyectos a medida en Java, C#, Python, React y Node.js.",
      "Consultoría tecnológica para microempresas e integración con bases de datos SQL y NoSQL.",
    ],
  },
];
